module.exports = __webpack_public_path__ + "media/mabani/mabani-slide3-7faac0c2.jpg";